// Font styles used in the application
export enum FontStyle {
  Normal = 'normal',
  Bold = 'bold',
  Italic = 'italic',
  Underline = 'underline',
  Strikethrough = 'strikethrough',
}